import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Values } from '../../../../values/Values';
import Grid from '@material-ui/core/Grid';
import EstoqueInsumoMovimentacaoResumidoTable
  from '../EstoqueInsumoMovimentacaoPorInsumoTable/EstoqueInsumoMovimentacaoPorInsumoTable';
import clsx from 'clsx';


const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: Values.cores.cinza
  },
  gridTabela: {
    margin: 20
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function DialogAnalisePorInsumo(props) {
  const classes = useStyles();
  const {
    open,
    setOpen,
    informacoes,
    setInformacoes,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
  } = props;

  const handleClose = () => {
    setOpen(false);
  };


  return (
    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" className={classes.title} >ANÁLISE POR INSUMO</Typography>
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          md={12}
          xs={12}
          className={clsx({
            [classes.gridTabela]: true
          })}
        >
          <EstoqueInsumoMovimentacaoResumidoTable
            movimentacoes={informacoes}
            setMovimentacoes={setInformacoes}
            setShowMessageSnack={setShowMessageSnack}
            setMessageSnack={setMessageSnack}
            setTypeSnack={setTypeSnack}
            mensagemSemDados={`Não foram encontradas movimentações para o filtro selecionado`}
            titulo={`Movimentações agrupadas por insumo`}
          />
        </Grid>
      </Grid>
    </Dialog>
  );
}

export default DialogAnalisePorInsumo;
